/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetConnexionListCommand,
  GetConnexionListResponse,
} from '../models/index';
import {
    GetConnexionListCommandFromJSON,
    GetConnexionListCommandToJSON,
    GetConnexionListResponseFromJSON,
    GetConnexionListResponseToJSON,
} from '../models/index';

export interface ExportAdminConnexionsCsvRequest {
    getConnexionListCommand: GetConnexionListCommand;
}

export interface GetAdminConnexionsRequest {
    getConnexionListCommand: GetConnexionListCommand;
}

/**
 * 
 */
export class ConnexionsApi extends runtime.BaseAPI {

    /**
     * Même commande et mêmes filtres/tri que la liste ; pagination ignorée, plafond 50 000 lignes. Colonnes Date (heure de Paris), Utilisateur, Action, Adresse IP, Navigateur. Permission BackOffice.AdminConnexions.Read (403 sinon). 
     * Exporter les connexions en CSV (BO admin)
     */
    async exportAdminConnexionsCsvRaw(requestParameters: ExportAdminConnexionsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['getConnexionListCommand'] == null) {
            throw new runtime.RequiredError(
                'getConnexionListCommand',
                'Required parameter "getConnexionListCommand" was null or undefined when calling exportAdminConnexionsCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/admin/connexions/liste/csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetConnexionListCommandToJSON(requestParameters['getConnexionListCommand']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Même commande et mêmes filtres/tri que la liste ; pagination ignorée, plafond 50 000 lignes. Colonnes Date (heure de Paris), Utilisateur, Action, Adresse IP, Navigateur. Permission BackOffice.AdminConnexions.Read (403 sinon). 
     * Exporter les connexions en CSV (BO admin)
     */
    async exportAdminConnexionsCsv(requestParameters: ExportAdminConnexionsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportAdminConnexionsCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Journal des connexions (journaux de sécurité ABP), trié par date décroissante. searchString et filters.userName filtrent l\'utilisateur (contient, insensible à la casse) ; filters.action en égalité (LoginSucceeded, LoginFailed, ImpersonateUser, ChangePassword) ; sans filters.period.startDate, 30 derniers jours ; fin de période inclusive sur le jour. Permission BackOffice.AdminConnexions.Read (403 sinon). 
     * Lister les connexions (BO admin)
     */
    async getAdminConnexionsRaw(requestParameters: GetAdminConnexionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConnexionListResponse>> {
        if (requestParameters['getConnexionListCommand'] == null) {
            throw new runtime.RequiredError(
                'getConnexionListCommand',
                'Required parameter "getConnexionListCommand" was null or undefined when calling getAdminConnexions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/admin/connexions/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetConnexionListCommandToJSON(requestParameters['getConnexionListCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConnexionListResponseFromJSON(jsonValue));
    }

    /**
     * Journal des connexions (journaux de sécurité ABP), trié par date décroissante. searchString et filters.userName filtrent l\'utilisateur (contient, insensible à la casse) ; filters.action en égalité (LoginSucceeded, LoginFailed, ImpersonateUser, ChangePassword) ; sans filters.period.startDate, 30 derniers jours ; fin de période inclusive sur le jour. Permission BackOffice.AdminConnexions.Read (403 sinon). 
     * Lister les connexions (BO admin)
     */
    async getAdminConnexions(requestParameters: GetAdminConnexionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConnexionListResponse> {
        const response = await this.getAdminConnexionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
